import { ActivateTaxSettingsDialog } from "@modules/finances/taxes/components/activateTaxSettingsDialog"
import { TaxSettingsDialog } from "@modules/finances/taxes/components/taxSettingsDialog"
import { createContext, type Dispatch, type SetStateAction, useState } from "react"

export const TaxDialogContext = createContext<{
  activateTaxDialogVisible: boolean
  taxSettingsDialogVisible: boolean
  setActivateTaxDialogVisible: Dispatch<SetStateAction<boolean>>
  setTaxSettingsDialogVisible: Dispatch<SetStateAction<boolean>>
}>({
  activateTaxDialogVisible: false,
  taxSettingsDialogVisible: false,
  setActivateTaxDialogVisible: () => {
    return
  },
  setTaxSettingsDialogVisible: () => {
    return
  },
})

export const TaxDialogProvider = ({ children }: { children: React.ReactNode }) => {
  const [activateTaxDialogVisible, setActivateTaxDialogVisible] = useState(false)
  const [taxSettingsDialogVisible, setTaxSettingsDialogVisible] = useState(false)

  return (
    <TaxDialogContext.Provider
      value={{
        activateTaxDialogVisible,
        taxSettingsDialogVisible,
        setActivateTaxDialogVisible,
        setTaxSettingsDialogVisible,
      }}
    >
      <TaxSettingsDialog />
      <ActivateTaxSettingsDialog />
      {children}
    </TaxDialogContext.Provider>
  )
}
